import {env} from '../../../../environment'

export const fetchTSReviews = (before: string | undefined) => {
  const url =
    env.getPixumPSI() +
    `?service=status&module=social&action=getTrustedshopReviews&count=420&brand=artbox&before=${before}`

  return fetch(url).then(response => response.json())
}
